import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, withLatestFrom } from 'rxjs/operators';
import { CommunicationService } from 'services/api/communication.service';
import { of } from 'rxjs';
import { Store } from '@ngrx/store';
import { requestFailure } from 'sharedStores/error/error.actions';
import { DocumentActions, DocumentSelectors } from './document.module';

@Injectable({ providedIn: 'any' })
export class DocumentEffects {
    constructor(
        private readonly actions$: Actions,
        private readonly store$: Store,
        private readonly communicationService$: CommunicationService,
    ) {}

    sendDisclosureDocumentEffect$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(DocumentActions.sendDisclosureDocumentRequest),
                withLatestFrom(this.store$.select(DocumentSelectors.selectEmailAddress)),
                mergeMap(([action, emailAddress]) =>
                    this.communicationService$.requestDisclosureDocument(emailAddress).pipe(
                        map((response) => {
                            return response;
                        }),
                        catchError((error) => of(requestFailure(error))),
                    ),
                ),
            ),
        {
            dispatch: false,
        },
    );
}
